// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import SimpleTable from "../SimpleTable"
import * as strings from "../../strings"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import {
  formatCurrency,
  formatDate,
  translationFunction,
} from "../../utils"

const PERCENTAGE_SYMBOL = "%"
const ID_ROW_PERCENTAGE = 10 // Having id row with 10% makes table more aligned
const LEFT_PERCENTAGE = 90
const NUMBER_OF_ROWS = 5
const ROW_PERCENTAGE = ( LEFT_PERCENTAGE / NUMBER_OF_ROWS ).toString() + PERCENTAGE_SYMBOL

const PAYMENT_AGREEMENT_COLUMNS = {
  id: { title: "ID", align: "left", width: ID_ROW_PERCENTAGE + PERCENTAGE_SYMBOL },
  effectiveDate: { title: strings.paymentAgreements.celebrationDate, align: "left", width: ROW_PERCENTAGE },
  agreedValue: { title: strings.paymentAgreements.agreedValue, align: "left", width: ROW_PERCENTAGE },
  paidValue: { title: strings.paymentAgreements.chargedValue, align: "left", width: ROW_PERCENTAGE },
  debtValue: { title: strings.paymentAgreements.debtValue, align: "left", width: ROW_PERCENTAGE },
  status: { title: strings.generalStrings.state, align: "left", width: ROW_PERCENTAGE },
}

class DebtPaymentAgreements extends Component {

  props: {
    paymentAgreements: any,
    idDebt: any,
    history: {
      push: () => {}
    },
    expanded?: boolean,
    onToggle?: () => any,
  }

  render () {
    return (
      <SimpleTable
        leftPadding="10px"
        columns={PAYMENT_AGREEMENT_COLUMNS}
        data={( _.compact( this.props.paymentAgreements ).length !== 0 ? this.props.paymentAgreements : [] ).map( paymentAgreement => {
          const agreedValue = _.sum( paymentAgreement.plannedPayments.map(
            plannedPayment => parseFloat( plannedPayment.value ) ) )
          const paidValue = _.sum( paymentAgreement.payments.map(
            payment => parseFloat( payment.value ) ) )
          return {
            ...paymentAgreement,
            effectiveDate: paymentAgreement.effectiveDate === null ? "--" : formatDate( paymentAgreement.effectiveDate ),
            agreedValue: formatCurrency( agreedValue ),
            paidValue: formatCurrency( paidValue ),
            debtValue: formatCurrency( agreedValue - paidValue ),
            status: translationFunction( paymentAgreement.status ),
            _onClick: () => this.props.history.push( "/paymentAgreement/" + paymentAgreement.id + "?debtId=" + this.props.idDebt ),
          }
        } )}
      />
    )
  }
}


export default withRouter( DebtPaymentAgreements )



// WEBPACK FOOTER //
// ./src/components/DebtPaymentAgreements/index.jsx